// extracted by mini-css-extract-plugin
export var contentContainer = "SenaryCard-module--contentContainer--069fb";
export var heading = "SenaryCard-module--heading--dd9a4";
export var image = "SenaryCard-module--image--31abb";
export var link = "SenaryCard-module--link--f343a";
export var linkText = "SenaryCard-module--linkText--f9bd9";
export var senary = "SenaryCard-module--senary--bfc7f";